/* THIS FILE IS GENERATED. DO NOT EDIT */

import { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { mergeProps } from '@/utils/merge';
import StandaloneImage from 'base/components/standalone/Image';

export const DynamicStandaloneImage = StandaloneImage;
export type DynamicStandaloneImageProps = PropsFromComponent<typeof StandaloneImage>;

export const DynamicStandaloneImageWith = (extras: DynamicStandaloneExtras): typeof StandaloneImage => {
    return function DynamicStandaloneImage(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'Image');
        return <StandaloneImage {...mergeProps({ options: { theme } }, props)} />;
    }
}